const TOKEN_KEY = "token";
const API_KEY = "apikey";

export function readSession(): { token: string | null; apiKey: string | null } {
  try {
    return { token: localStorage.getItem(TOKEN_KEY), apiKey: localStorage.getItem(API_KEY) };
  } catch {
    return { token: null, apiKey: null };
  }
}

export function clearSession(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(API_KEY);
  } catch {
    /* storage non disponibile */
  }
}

export function writeSession(session: { token: string; apiKey: string }): void {
  try {
    localStorage.setItem(TOKEN_KEY, session.token);
    localStorage.setItem(API_KEY, session.apiKey);
  } catch {
    /* storage non disponibile */
  }
}
